import PropTypes from "prop-types";
import React from "react";

import { Text, textPropTypes } from "@swa-ui/core";
import globalRules from "@swa-ui/core/assets/styles/globalRules.module.scss";
import i18n from "@swa-ui/locale";
import { classNames } from "@swa-ui/string";

import { FlightDuration } from "../FlightDuration";
import { getShortDisplayStationName } from "../Stations";
import styles from "./StopDuration.module.scss";

/**
 * StopDuration displays the time and location related to the layover of the current connecting flight.
 */
export const StopDuration = (props) => {
  const { airportCode, changePlanes, className, durationTime, textProps } = props;

  return (
    <div className={classNames(className, styles.stopDuration)}>
      <Text {...getTextProps()}>
        <span className={globalRules.hiddenFromScreen}>
          {i18n("StopDuration__CHANGE_PLANES_ARIA_LABEL")}
        </span>
        <span aria-hidden="true">{airportCode}</span>,&nbsp;
        <span className={globalRules.hiddenFromScreen}>
          {getShortDisplayStationName(airportCode)}
        </span>
        <FlightDuration {...getDurationProps()} />
      </Text>
    </div>
  );

  function getTextProps() {
    const { prefixIcon, ...textPropsWithoutPrefixIcon } = textProps ?? {};

    return {
      className: styles.content,
      ...(changePlanes && { prefixIcon: { name: "ChangePlanes" } }),
      ...textPropsWithoutPrefixIcon,
    };
  }

  function getDurationProps() {
    return {
      "aria-label": i18n("StopDuration__STOP_DURATION_ARIA_LABEL"),
      duration: durationTime,
      separator: " ",
    };
  }
};

StopDuration.propTypes = {
  /** Value for the airport code for the stop location. */
  airportCode: PropTypes.string,

  /** Boolean value for if the flight leg has a plane change. */
  changePlanes: PropTypes.bool,

  /** Additional class to be added to the outermost element for positioning the component. */
  className: PropTypes.string,

  /** Value for duration of the stop in minutes. */
  durationTime: PropTypes.number.isRequired,

  /** Props to pass to Text component that will style the time portion of what is rendered. */
  textProps: PropTypes.shape(textPropTypes),
};
